import React from "react";
import { SectionDivider, ParentContainer, LeftContainer, RightContainer, Title, BodyTitle, Body, Img, ImageWrapper } from './HeroStyles'
import profile from '../Profile.jpg';
import { motion } from "framer-motion";

const Hero = () => (
    <div style={{  }}>
        <motion.div initial={{opacity: 0, y: 100}} animate={{opacity: 1, y: 0}} transition={{duration: 1}} >
        <SectionDivider />
        <ParentContainer style={{  }}>
            <LeftContainer style={{  }}>
                <Title>Greetings!</Title>
                <BodyTitle>
                    I'm Kanav Jain
                </BodyTitle>
                <Body style={{ border: '2px solid white', borderRadius: '10px' }}>
                    Mechatronic Systems Engineering Student <br/>
                    Ex-Software Developer and Electrical Engineering Intern
                    Musician, gym enthusiast, and smth!
                </Body>
            </LeftContainer>
            <RightContainer style={{  }}>
                <ImageWrapper>
                    <Img src={profile} />
                </ImageWrapper>
            </RightContainer>
        </ParentContainer>
        </motion.div>
    </div>
);

export default Hero;